var _rect, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2038_22360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2038_22360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5664 15.0336H12.4336V12.4336H15.0336V11.5664H12.4336V8.96639H11.5664V11.5664H8.96639V12.4336H11.5664V15.0336ZM12.2 18.0664C11.3445 18.0664 10.5363 17.9083 9.77519 17.592C9.01413 17.2752 8.35013 16.8445 7.78319 16.3C7.21679 15.7555 6.76693 15.1165 6.43359 14.3832C6.10026 13.6499 5.93359 12.8611 5.93359 12.0168C5.93359 11.1832 6.09173 10.3944 6.40799 9.65039C6.72479 8.90586 7.15813 8.26133 7.70799 7.71679C8.25839 7.17226 8.90293 6.73893 9.64159 6.41679C10.3808 6.09466 11.1669 5.93359 12 5.93359C12.8555 5.93359 13.6499 6.10026 14.3832 6.43359C15.1165 6.76693 15.7555 7.21973 16.3 7.79199C16.8445 8.36373 17.2752 9.03306 17.592 9.79999C17.9083 10.5669 18.0664 11.3835 18.0664 12.2496V17C18.0664 17.2891 17.9611 17.5392 17.7504 17.7504C17.5392 17.9611 17.2891 18.0664 17 18.0664H12.2ZM12 17.2C13.4443 17.2 14.672 16.6944 15.6832 15.6832C16.6944 14.672 17.2 13.4443 17.2 12C17.2 10.5557 16.6944 9.32799 15.6832 8.31679C14.672 7.30559 13.4443 6.79999 12 6.79999C10.5557 6.79999 9.32799 7.30559 8.31679 8.31679C7.30559 9.32799 6.79999 10.5557 6.79999 12C6.79999 13.4443 7.30559 14.672 8.31679 15.6832C9.32799 16.6944 10.5557 17.2 12 17.2Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCompany);
export default __webpack_public_path__ + "static/media/AddCompany.d30ba7520a130ed24a070469491ffcb3.svg";
export { ForwardRef as ReactComponent };